import React, { Component } from 'react';
class LimiteCompra extends Component {
    constructor(props) {
        super(props);

        this.state = {
            valorLimiteCompra: this.props.data.LimiteDeCompraClienteAdicionalSeleccionado
        };
    }

    onInputChange(e) {
        const { value, dataset } = e.target;
        if(/^[0-9]*$/g.test(value) || value == ""){
            this.props.changeInput(dataset.code, value)
        }
    }

    componentDidMount(){
        //POR DEFAULT SE CARGA EL LÍMITE DE COMPRA DE LA CUENTA
        if(!this.props.data.LimiteCompraCabal){
            this.props.changeInput("LimiteDeCompraClienteAdicionalSeleccionado",this.props.tarjetas.solicitudCuenta.limiteCompra);
        }
    }

    render() {
        const { data, changeInput, tarjetas } = this.props
        let limiteCuenta = (this.props.tarjetas.solicitudCuenta && this.props.tarjetas.solicitudCuenta.limiteCompra) ? parseInt(this.props.tarjetas.solicitudCuenta.limiteCompra) : 0;
        let limiteAdicional = this.props.data.LimiteDeCompraClienteAdicionalSeleccionado && this.props.data.LimiteDeCompraClienteAdicionalSeleccionado != "" && this.props.data.LimiteDeCompraClienteAdicionalSeleccionado >0  ? parseInt(this.props.data.LimiteDeCompraClienteAdicionalSeleccionado) : null; 
        
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">Límites</label>
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Límite de Compra</label>
                        </div>
                        <div className="col-xs-3">
                            <input className="input-separate inputAlta" 
                                placeholder="Ingrese Monto..."
                                type="text"
                                data-code="LimiteDeCompraClienteAdicionalSeleccionado"
                                value={this.props.data.LimiteDeCompraClienteAdicionalSeleccionado}
                                onChange={this.onInputChange.bind(this)}
                            />
                        </div>
                        <div className="col-xs-6">
                            <label className="label-secondary">{("( Monto Máximo $" + tarjetas.solicitudCuenta.limiteCompra+" )")}</label>
                        </div>
                    </div>
                {(data.ERROR_ADICIONAL["seleccionoLimitesCabal"] == false && !limiteAdicional)
                    && <label className="error">{"Debe agregar un límite de compra"}</label>
                }
                {(data.ERROR_ADICIONAL["seleccionoLimitesCabal"] == false && limiteAdicional && limiteAdicional>limiteCuenta )
                    && <label className="error">{"El límite de compra debe ser menor o igual al de la cuenta"}</label>
                }
                </div>
            </div>
        )
    }
};

export default LimiteCompra;